var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalDepartment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 64,
    transform: "translate(0 0.001)",
    fill: "none",
    stroke: "#bdbcbc",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-298 -714)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0c50,0,50,0,50,50s0,50-50,50S0,100,0,50,0,0,50,0Z",
    transform: "translate(303 493)",
    fill: "#ebedf0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.185 732.27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.185 -0.27)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.93,10.684V57.229L2.7,61.336H43.773l2.909-1.027,1.2-3.08V14.277H36.243V2.3H4.073L2.7,3.5.93,5.207Z",
    fill: "#bdbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.885,1.8H36.743V13.777H48.38V57.322L47.065,60.7l-3.206,1.132H2.375L.43,57.332V4.995L2.375,3.12Zm31.858,1H4.261L3.042,3.864,1.43,5.419V57.125l1.6,3.711H43.687l2.612-.922,1.081-2.779V14.777H35.743Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.992-.5H35.945a1.5,1.5,0,0,1,1.5,1.5V11.98h10.98a1.5,1.5,0,0,1,1.5,1.5V55.913A6.5,6.5,0,0,1,43.433,62.4H5.992A6.5,6.5,0,0,1-.5,55.913V5.992A6.5,6.5,0,0,1,5.992-.5Zm28.452,3H5.992A3.5,3.5,0,0,0,2.5,5.992V55.913A3.5,3.5,0,0,0,5.992,59.4H43.433a3.5,3.5,0,0,0,3.492-3.492V14.98H35.945a1.5,1.5,0,0,1-1.5-1.5Z",
    transform: "translate(-0.07 0.891)",
    fill: "#bdbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29-.5a1.5,1.5,0,0,1,1.061.439l12.48,12.48A1.5,1.5,0,0,1,41.48,14.98H29a1.5,1.5,0,0,1-1.5-1.5V1A1.5,1.5,0,0,1,29-.5Zm8.859,12.48L30.5,4.621V11.98Z",
    transform: "translate(6.875 0.891)",
    fill: "#bdbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.459,36.515H9A1.512,1.512,0,1,1,9,33.49H36.459a1.512,1.512,0,1,1,0,3.025Z",
    transform: "translate(1.912 9.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.459,30.515H9A1.512,1.512,0,1,1,9,27.49H36.459a1.512,1.512,0,0,1,0,3.025Z",
    transform: "translate(1.912 7.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.459,24.515H9A1.512,1.512,0,0,1,9,21.49H36.459a1.512,1.512,0,0,1,0,3.025Z",
    transform: "translate(1.912 6.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.459,18.515H9A1.512,1.512,0,0,1,9,15.49H36.459a1.512,1.512,0,0,1,0,3.025Z",
    transform: "translate(1.912 4.857)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalDepartment);
export default __webpack_public_path__ + "static/media/Legal-Department.6f13bdcdc00fb7c9e05b12e8e027824e.svg";
export { ForwardRef as ReactComponent };